import { Container } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { OrgUserDetailsProvider } from 'src/hooks/useOrgUserDetails';
import OrgUserDetailsLoader from '../OrgUserDetails/OrgUserDetailsLoader';

const UserDetailsPage: React.FC = () => {
  const { UID } = useParams();
  const { user } = useAuth();
  const { organisationId } = user;
  const { associateId } = useParams();
  const orgId = useMemo(
    () => (associateId ? associateId : organisationId),
    [associateId, organisationId]
  );

  return (
    <Container disableGutters maxWidth="xl">
      <OrgUserDetailsProvider userId={UID} orgId={orgId}>
        <OrgUserDetailsLoader userId={UID} orgId={orgId} />
      </OrgUserDetailsProvider>
    </Container>
  );
};

export default UserDetailsPage;
